import type { CSSProperties, ReactNode } from 'react';

export interface ChartLegendItem {
  id: string;
  label: string;
  /** A resolved colour from `useChartTheme().color()`. */
  color: string;
  /** Text after the label, e.g. `42% • 12 items`. */
  detail?: ReactNode;
  /** Hover text explaining the item. */
  title?: string;
}

/** The one legend: an HTML list, a dot per item, never Nivo's canvas legend (DESIGN.md §8.1). */
export function ChartLegend({
  items,
  className = 'flex flex-wrap gap-x-4 gap-y-2',
}: {
  items: ChartLegendItem[];
  className?: string;
}) {
  return (
    <ul className={`text-sm ${className}`}>
      {items.map((item) => (
        <li
          key={item.id}
          title={item.title}
          className="flex items-center gap-2 text-gray-800 dark:text-white/90"
        >
          <span
            aria-hidden="true"
            className="size-3 shrink-0 rounded-full bg-(--dot)"
            style={{ '--dot': item.color } as CSSProperties}
          />
          <span>{item.label}</span>
          {item.detail && <span className="text-gray-500 dark:text-gray-400">{item.detail}</span>}
        </li>
      ))}
    </ul>
  );
}
